module.exports = __webpack_public_path__ + "img/phoenix_kedel_4.4de9769d.png";